let dirtyCallback = () => { return false; }

export default function dirtyHandler() {

	const isDirty = () => {
		if (dirtyCallback) return dirtyCallback();
		else return false;
	}
	
	const setDirty = (isDirtyFunction) => {
		if (isDirtyFunction) dirtyCallback = isDirtyFunction;
	};

	return {
		isDirty: isDirty,
		setDirty: setDirty
	}	
};